import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { Component } from '@angular/core';
import { Icon } from '../../../../../components/icon/icon.component';
import { CellAdapter } from '../cell-adapter.component';

@Component({
  selector: 'lepi-drag-handler-cell',
  template: ` <div class="drag-handler-cell flex items-center" cdkDragHandle>
    <lepi-icon name="ic:sharp-menu" />
  </div>`,
  standalone: true,
  imports: [Icon, CdkDragHandle],
})
export class DragHandlerCell extends CellAdapter {}
